import axios from "axios";
import {
  webApiCarrusel,
  webApiCarruselTextos,
  webApiContenido,
  webApiInstituciones,
  webApiLineaTiempo,
  webApiMenu,
  webApiSubmenu,
} from "../routes/endpoints";

/** GET requests*/

export const getCarruselTextosData = async () => {
  const res = await axios.get(webApiCarruselTextos);
  const { data } = res;
  return data;
};

export const getCarruselData = async () => {
  const res = await axios.get(webApiCarrusel);
  const { data } = res;
  return data;
};

export const getTiempoData = async () => {
  const res = await axios.get(webApiLineaTiempo);
  const { data } = res;
  return data;
};

export const getInstitucionesData = async () => {
  const res = await axios.get(webApiInstituciones);
  const { data } = res;
  return data;
};

export const getContenidoData = async () => {
  const res = await axios.get(webApiContenido);
  const { data } = res;
  return data;
};

/** POST requests*/

export const getMenuByIdData = async (id: string) => {
  const res = await axios.post(webApiMenu, { id: id });
  const { data } = res;
  return data;
};

export const getSubmenuByIdData = async (id: string) => {
  const res = await axios.post(webApiSubmenu, { id: id });
  const { data } = res;
  return data;
};
